// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface TransferMajorLactsCategoryDTO extends EntitySelectorDTO { 
	id: number;
	name: string | null;
}

const TransferMajorLactsCategoryDTO = {
    className: 'TransferMajorLactsCategoryDTO',
    create: (initValues?: Partial<TransferMajorLactsCategoryDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: 0,
			name: "",
        },
        initValues);
    },
	id: 'id',
	name: 'name',
};

export default TransferMajorLactsCategoryDTO;